const billingEN = {
	title: "Billing & Subscription",
	loading: "Loading...",
	errorLoading: "We couldn't load your billing details right now. Please try again.",

	currentSubscription: "Current Subscription",
	noSubscription: "No subscription found.",
	startSubscription: "Start subscription",

	pricePerInterval: "{currency} {amount} / {interval}",
	nextBillingOn: "Next billing: {date}",
	serviceEndsOn: "Your subscription ends on {date}",
	status: "Status",
	billingInterval: "Every {frequency} {interval}(s)",

	buttons: {
		updatePaymentMethod: "Update payment method",
		cancelSubscription: "Cancel subscription",
		manageSubscription: "Manage subscription",
	},

	scheduledCancel: {
		title: "Your subscription is scheduled to cancel",
		body: "Your subscription will be cancelled on {date}. Nothing changes until then, but after that date your business is hidden from search and can't take new bookings. You can undo this any time before then.",
		bodyNoDate:
			"Your subscription is scheduled to cancel at the end of the current period. After that, your business is hidden from search and can't take new bookings.",
		keepButton: "Keep my subscription",
		resumed: "Done — we've called off the cancellation and your subscription carries on as normal.",
	},

	suspension: {
		suspendedTitle: "Your business is suspended",
		suspendedBody:
			"We couldn't process your subscription payment, so your business is hidden from search and can't take new bookings. Your existing bookings are safe. Reactivate to go live again straight away.",
		warningTitle: "There's a problem with your payment",
		warningBody:
			"We couldn't process your last payment. You have {days} day(s) to sort it out before your business is suspended and hidden from search.",
		reactivateButton: "Reactivate my business",
		fixPaymentButton: "Fix my payment",
		working: "Just a moment...",
		updateOpened: "We've opened your payment page in a new tab. Your business goes live again as soon as the payment clears.",
		reactivated: "You're all set — your business is live again.",
		error: "We couldn't start the reactivation. Please try again, or contact support if it keeps happening.",
	},

	paymentMethod: {
		title: "Payment Method",
		noStored: "No payment method stored yet.",
		brand: "Brand",
		last4: "Last 4",
		expires: "Expires",
	},

	billingInfo: {
		title: "Billing Info",
		started: "Started",
		firstBilled: "First billed",
		nextBilling: "Next billing",
		interval: "Interval",
	},

	upcomingPayment: {
		title: "Upcoming Payment",
		date: "Date",
		subtotal: "Subtotal",
		discount: "Referral Discount",
		totalDue: "Total Due",
	},

	transactions: {
		title: "Transaction History",
		date: "Date",
		invoice: "Invoice",
		subtotal: "Subtotal",
		discount: "Discount",
		total: "Total",
		status: "Status",
		noInvoice: "—",
	},

	referralCredits: {
		title: "Referral Credits",
		availableCredit: "available credit",
		creditBalance: "Credit Balance",
		rewardsEarned: "Rewards earned",
		referral: "referral",
		referrals: "referrals",
		usedCode: "Used Code",
		code: "Code",
		status: "Status",
		shopsReferred: "Shops You Referred",
		rewarded: "Rewarded",
		statusLabels: {
			pending_billing: "Awaiting first payment",
			pending_referrer_payment: "Awaiting referrer's first payment",
			reward_issued: "Discount applied ✓",
		},
	},

	discount: {
		active: "🎉 Referral discount active",
		appliedRange: "Applied {from} → {to}",
	},

	plans: {
		title: "Available Plans",
		options: "{count} options",
		choosePlan: "Choose plan",
	},

	seatCap: {
		note: "{staff} team members, {billed} billed. Seats past {max} are always free.",
	},

	seats: {
		activeSeats: "{count} seat(s) active",
		seatPricing: "{currency} {amount} per seat / month",
		total: "Total billed: {currency} {total}",
	},

	statusBadge: {
		active: "Active",
		canceled: "Canceled",
		paused: "Paused",
		trialing: "Trialing",
		past_due: "Past due",
		unpaid: "Unpaid",
		incomplete: "Incomplete",
		incomplete_expired: "Expired",
		completed: "Completed",
		paid: "Paid",
		pending: "Pending",
		cancelScheduled: "Cancellation scheduled",
	},

	referral: {
		title: "Referral Program",
		loading: "Loading...",
		noCode: "You do not have a referral code yet.",
		generate: "Generate Referral Code",
		codeLabel: "Your Code:",
		copyCode: "Copy Code",
		copyLink: "Copy",
		copied: "Copied to clipboard",
		linkCopied: "Link copied!",
		linkLabel: "Referral Link",
		historyTitle: "Referral History",
		noReferrals: "No referrals yet.",
		defaultShopName: "New Shop",
		applyTitle: "Referral Code",
		applyPlaceholder: "Enter referral code",
		applyButton: "Apply",
		applyLoading: "...",
		usingCode: "Using code:",
		applied: "All set! Referral code applied.",
		errorLoad: "We couldn't load your referral info.",
		errorGenerate: "We couldn't generate your referral code. Please try again.",
		errorApply: "We couldn't apply that referral code. Please check it and try again.",
		status: {
			pending: "Pending",
			active: "Active",
			converted: "Converted",
		},
	},

	misc: {
		month: "month",
	},
};

export default billingEN;
